import React from 'react';

interface MaterialIconProps {
  icon: string;
  size?: number;
  fill?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Material Symbols Sharp icon component.
 * Requires the font loaded in index.css.
 */
export const MaterialIcon: React.FC<MaterialIconProps> = ({
  icon,
  size = 24,
  fill = false,
  className = '',
  style,
}) => {
  return (
    <span
      className={`material-symbols-outlined${fill ? ' fill-1' : ''} ${className}`.trim()}
      style={{ fontSize: size, ...style }}
      aria-hidden="true"
    >
      {icon}
    </span>
  );
};
